const defaultAvatar = require('@/static/pic/litangbao.png')

export function safeAvatarUrl(url) {
  if (!url || url === '未设置' || String(url).includes('i.postimg.cc')) {
    return defaultAvatar
  }
  return url
}
